import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBlock } from './models';

export const Block: FC<React.PropsWithChildren<TBlock>> = props => {
    const {
        border,
        borderColor,
        borderRadius,
        children,
        className,
        dataTestId,
        fullHeight,
        id,
        inner,
        innerRef,
        notPadded,
        overflowHidden,
        paddedType = 'standard',
        shadow = false,
        styles,
        theme = 'transparent',
        ...rest
    } = props;

    // Для обратной совместимости, когда borderRadius был true/false, и в случае true был равен 4px
    const borderRadiusSize = borderRadius === true ? 4 : borderRadius;

    const classNames = cn(
        styles.block,
        styles[theme],
        {
            [styles[paddedType]]: !notPadded,
            [styles.inner]: inner,
            [styles.border]: border && !borderColor,
            /*
             * TODO: Бордер пока в camelCase не перевести быстро, так как в пропс передаются значения такого типа dark-indigo-20
             * Плюс нужно учесть обратную совместимость в ASSR
             */
            [styles[`border-${borderColor}`]]: borderColor,
            [styles[`borderRadius${borderRadiusSize}`]]: borderRadius,
            [styles.fullHeight]: fullHeight,
            [styles.shadow]: shadow,
            [styles.overflowHidden]: overflowHidden,
        },
        className
    );

    return (
        <div ref={innerRef} className={classNames} data-test-id={dataTestId} id={id} {...rest}>
            {children}
        </div>
    );
};
